export default "__VITE_ASSET__4e9520e0__"